import CommunicationToolsPage from "../../components/communication-tools";

const campaignsPageProps = {
  heroTitle: "Create Targeted SMS\nCampaigns That Drive\nReal Results",
  heroDescription:
    "With SleengShort’s SMS Campaigns, you can design and execute messaging strategies that resonate with your audience. Our platform makes it easy to segment contacts, automate campaigns, and track performance—all from one intuitive dashboard.",
  heroImage:
    "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330378/sleenshort/campaigns/rm8koo9iyku7dsuuk9cq.png",

  whyChooseTitle: "Why Choose SleengShort SMS Campaign service",
  features: [
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330377/sleenshort/campaigns/c3qmw3xwosszv6e6dapp.png",
      title: "98% Open Rate",
      descr: "Send messages to any mobile device, anywhere in the world",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330377/sleenshort/campaigns/bcl7izzwt23vvj9khdop.png",
      title: "High Engagement",
      descr: "Customers are 6x more likely to respond to SMS than email.",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330376/sleenshort/campaigns/clebnjiabpn03qzx3hwa.png",
      title: "Cost-Effective",
      descr:
        "Achieve higher ROI with lower costs compared to traditional marketing.",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330376/sleenshort/campaigns/jpxksivydujt803whv6a.png",
      title: "Contact Segmentation",
      descr: "Send the right message to the right audience.",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330376/sleenshort/campaigns/wsxr7xxu9i2nutsqe54w.png",
      title: "Automation",
      descr: "Set up drip campaigns and trigger-based messages.",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330376/sleenshort/campaigns/wwrlf4n5lyrthxpybfrt.png",
      title: "Analytics",
      descr: "Measure open rates, click-through rates, and conversions.",
    },
  ],

  useCaseTitle: "Use Case",
  useCases: [
    {
      img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330380/sleenshort/campaigns/urfnkjfmjp0ktsdmoxzj.png",
      title: "Promotions",
      descr: "Drive sales with limited-time offers.",
    },
    {
      img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330378/sleenshort/campaigns/y4dde7jyylzlytteflmq.png",
      title: "Customer Retention",
      descr: "Reward loyal customers with exclusive deals.",
    },
    {
      img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330379/sleenshort/campaigns/uerejzlntxziz1gx9tao.png",
      title: "Event Marketing",
      descr: "Send reminders and updates for webinars, conferences, and more.",
    },
  ],
};

const CampaignsPage = () => {
  return <CommunicationToolsPage {...campaignsPageProps} />;
};

export default CampaignsPage;
